import { isTouchDevice } from 'Utils/agent';

import template from './cardFlow.html';

const component = {
  name: 'pcCardFlow',
  template,
  controller: pcCardFlowController,
  bindings: {
    items: '<',
    current: '<?',
    duration: '<?',
    currentCb: '&?'
  }
};

/* @ngInject */
function pcCardFlowController($scope, $interval, CardFlowService, growl, hotkeys) {
  const vm = this;

  let count = 1;
  let start = 0;
  let killSwitchForLoader = false;

  let timesArrowClicked = 0;
  let hotkeyInfoActive = !isTouchDevice();

  // exposed variables
  vm.playInterval = null;

  // exposed functions
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = destroyIntervalAndLoader;
  vm.nextCard = nextCard;
  vm.previousCard = previousCard;
  vm.togglePlay = togglePlay;
  vm.shouldShowPreviousButton = shouldShowPreviousButton;
  vm.shouldShowNextButton = shouldShowNextButton;

  hotkeys
    .bindTo($scope)
    .add({
      combo: 'left',
      callback: _.throttle(() => {
        hotkeyInfoActive = false;
        previousCard();
      }, 1000 / 5)
    })
    .add({
      combo: 'right',
      callback: _.throttle(() => {
        hotkeyInfoActive = false;
        nextCard();
      }, 1000 / 5)
    });


  function init() {
    if (!vm.current) {
      vm.current = 0;
    }

    loadNextImages();
  }

  function postLink() {
    if (vm.currentCb) {
      $scope.$watch(() => vm.current, (newV, oldV) => {
        if (newV !== oldV) {
          vm.currentCb({ newCurr: vm.current });
        }
      });
    }
  }

  function loadNextImages() {
    CardFlowService.load(vm.items, count, start)
      .then(() => {
        const maxCount = 5;
        start += count;
        if (count < maxCount) {
          count += 1;
        }
        if ((start + count) > vm.items.length) {
          count = vm.items.length - start;
        }
        if ((start < vm.items.length) && !killSwitchForLoader) {
          loadNextImages();
        }
      });
  }

  function nextCard() {
    if ((vm.current + 1) < vm.items.length) {
      vm.current += 1;
    } else {
      vm.current = 0;
    }
    tryHotkeyInfo();
  }

  function previousCard() {
    if ((vm.current - 1) >= 0) {
      vm.current -= 1;
    } else {
      vm.current = vm.items.length - 1;
    }
    tryHotkeyInfo();
  }

  function tryHotkeyInfo() {
    if (hotkeyInfoActive && ++timesArrowClicked === 10) {
      hotkeyInfoActive = false;
      growl.info(
        'You can press the arrow keys to move between recordings \n[←] Previous \n[→] Next',
        { title: 'Tip: keyboard shortcuts' }
      );
    }
  }

  function togglePlay() {
    if (vm.playInterval) {
      $interval.cancel(vm.playInterval);
      vm.playInterval = null;
    } else {
      if (!vm.duration) {
        vm.duration = 1000;
      }
      vm.playInterval = $interval(nextCard, vm.duration);
    }
  }

  function shouldShowPreviousButton() {
    return vm.current > 0;
  }

  function shouldShowNextButton() {
    return vm.current < (vm.items.length - 1);
  }

  function destroyIntervalAndLoader() {
    if (vm.playInterval) {
      $interval.cancel(vm.playInterval);
      vm.playInterval = null;
    }
    killSwitchForLoader = true;
  }
}

export default component;
